import type { CSSProperties } from "react";

export const TEAL = "#0F9599";
export const TEAL_DARK = "#0B7377";
export const LINK_BLUE = "#0077C5";
export const INK = "#0E1A1A";
export const SUB = "#5B6B6B";
export const BORDER = "#DDE5E5";
export const FOOTER_DARK = "#0B3D3D";
export const BG_PROMO = "#F1F5F5";

export const linkStyle: CSSProperties = {
  color: LINK_BLUE,
  textDecoration: "none",
  fontWeight: 600,
};

export const ulStyle: CSSProperties = {
  margin: "8px 0",
  paddingLeft: 22,
  lineHeight: 1.8,
};

export const olStyle: CSSProperties = {
  margin: "8px 0",
  paddingLeft: 22,
  lineHeight: 1.8,
};